import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import Box from '../Box';
import './styles.scss';

export const Page = ({children, className, isNotAllowed = false}) => (
  <Box className={classNames('page-section', className)} tag="section" direction="column">
    {!isNotAllowed ? children :   
    <div className="flex flex-jc-c ai-i-c" style={{ marginTop: '40%' }}> You don't have permission to view this page. </div> }

  </Box>
);

Page.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

export default Page;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/layout/Page/index.js